import { isNarrowView, isMobileView } from '../utilities/index.js';

(function () {
  'use strict';

  const CLASS = {
    topPage: 'page-top',
    whiteHeader: 'l-header--white',
    fixedHeader: 'is-fixed',
    active: 'is-active'
  };

  const body = document.body;
  const isTopPage = body.classList.contains(CLASS.topPage);
  const header = document.querySelector('.l-header');
  const topMv = document.getElementById('js-top-mv');
  const cvCareer = document.getElementById('js-cvCareer');
  const bgChangeTrigger = document.querySelector('.js-bg-change-trigger');
  

  const fadeInHeader = () => {
    if (header && !header.classList.contains(CLASS.active)) {
      if(isTopPage) {
        setTimeout(()=>{
          header.classList.add(CLASS.active);
        }, 1300)
      } else {
        header.classList.add(CLASS.active);
      }
    }
  };

  const checkScrollPosition = () => {
    const scrollY = window.scrollY || window.pageYOffset;

    // 固定ヘッダー制御
    if (scrollY > 100) {
      header.classList.add(CLASS.fixedHeader);
    } else {
      header.classList.remove(CLASS.fixedHeader);
    }

    let needsWhiteHeader = false;

    // トップページ：MVの範囲内でwhiteHeader
    if (isTopPage && topMv) {
      const mvBottom = topMv.getBoundingClientRect().bottom + window.scrollY;
      if (scrollY <= mvBottom) {
        needsWhiteHeader = true;
      }
    }

    // ナロービューかつcvCareerに到達したらwhiteHeader
    if (isNarrowView() && cvCareer) {
      const cvCareerTop = cvCareer.getBoundingClientRect().top + window.scrollY;
      const headerHeight = header.offsetHeight;

      if (scrollY + headerHeight >= cvCareerTop) {
        needsWhiteHeader = true;
      }
    }

    // モバイルビューかつjs-bg-change-trigger に達していたら whiteHeader
    // ※「/career/message/」ページで使用
    if (isMobileView() && bgChangeTrigger) {
      const triggerRect = bgChangeTrigger.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const offset = 300;
      const lowerThreshold = windowHeight - offset;
      const upperThreshold = 0 + offset;

      const isInView = triggerRect.top < lowerThreshold && triggerRect.bottom > upperThreshold;

      if (isInView) {
        needsWhiteHeader = true;
      }
    }

    // モバイルビューかつ.page-career__mvの範囲内ならwhiteHeader
    if (isMobileView()) {
      const careerMv = document.querySelector('.page-career__mv');
      if (careerMv) {
        const mvTop = careerMv.getBoundingClientRect().top + window.scrollY;
        const mvBottom = mvTop + careerMv.offsetHeight;

        if (scrollY >= mvTop && scrollY <= mvBottom) {
          needsWhiteHeader = true;
        }
      }
    }

    // クラス操作
    if (needsWhiteHeader) {
      if (!header.classList.contains(CLASS.whiteHeader)) {
        header.classList.add(CLASS.whiteHeader);
      }
    } else {
      if (header.classList.contains(CLASS.whiteHeader)) {
        header.classList.remove(CLASS.whiteHeader);
      }
    }
  };

  window.addEventListener('scroll', checkScrollPosition);
  window.addEventListener('load', () => {
    fadeInHeader();
    checkScrollPosition();
  });
  window.addEventListener('resize', checkScrollPosition);
})();
